  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_CardsService = {
  wu_cards_cardslist,                  //Session=Y,GET
  wu_cards_cards_delete,               //Session=Y,POST
};
//----------------------------------------------------------------------------------------------------
function wu_cards_cardslist(reqData) {
  const methName = "wu_cards_cardslist ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/cards/list";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_cards_cards_delete(reqData) {
  const methName = "wu_cards_cards_delete ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/cards/delete";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "token" : reqData.token
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
